import type { World } from '../ecs/world'

/** Presentation-state bookkeeping: flash timers, particles, shake, lifetimes. */
export function fxSystem(world: World, dt: number): void {
  for (const e of world.entities) {
    if (e.flash > 0) e.flash -= dt
    if (e.kind === 'corpse' || e.kind === 'fx') {
      e.lifetime = (e.lifetime ?? 0) - dt
      if (e.lifetime <= 0) e.dead = true
    }
  }
  let w = 0
  const ps = world.particles
  for (let i = 0; i < ps.length; i++) {
    const p = ps[i]!
    p.life -= dt
    if (p.life <= 0) continue
    p.x += p.vx * dt
    p.y += p.vy * dt
    p.vx *= 1 - 3 * dt
    p.vy *= 1 - 3 * dt
    ps[w++] = p
  }
  ps.length = w
  world.shake = Math.max(0, world.shake - world.tuning.feel.shakeDecay * dt)
}

/** store previous positions for render interpolation — run FIRST each tick */
export function snapshotPositions(world: World): void {
  for (const e of world.entities) {
    e.px = e.x
    e.py = e.y
  }
}
